// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--22769";
export var hidden = "Footer-module--hidden--d139a";